import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import * as CryptoJS from "crypto-js";
@Injectable({
  providedIn: "root",
})
export class SubscriptionService {
  model = {};
  options: any;
  prod: any = [];
  user: any;
  encryptedData: any;
  language: any;

  UpdateArray(newObject: any) {
    this.prod = newObject;
  }

  constructor(private http: HttpClient) {
    this.updateToken();
  }
  updateToken(): void {
    this.language = JSON.parse(
      localStorage.getItem(environment.localStorageLangKey)
    );
    this.encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.encryptedData) {
      this.encryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      const headers = new HttpHeaders()
        .set("language", this.language)
        .set("Authorization", "Bearer " + this.encryptedData.token)
        .set("Content-Type", "application/x-www-form-urlencoded");
      this.options = { headers };
    }
  }
  subscriptionPlanInfo() {
    this.updateToken();
    return this.http.get(
      environment.planApiUrl + "subscription/plan",
      this.options
    );
  }
  add_subscription(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("stripe_plan_id", data.stripe_plan_id)
      .set(
        "stripe_coupon_id",
        data.stripe_coupon_id ? data.stripe_coupon_id : ""
      )
      .set("coupon_id", data.coupon_id ? data.coupon_id : "")
      .set("discount_amount", data.discount_amount ? data.discount_amount : "")
      .set("source", data.source);
    return this.http.post(
      environment.planApiUrl + "subscription",
      body,
      this.options
    );
  }
  upgrade_subscription(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("stripe_plan_id", data.stripe_plan_id)
      .set(
        "stripe_coupon_id",
        data.stripe_coupon_id ? data.stripe_coupon_id : ""
      )
      .set("coupon_id", data.coupon_id ? data.coupon_id : "")
      .set("discount_amount", data.discount_amount ? data.discount_amount : "")
      .set("source", data.source);
    return this.http.post(
      environment.apiUrl + "subscription/upgradeWeb",
      body,
      this.options
    );
  }
  promoCode(data: any): Observable<any> {
    const body = new HttpParams().set("code", data);
    return this.http.post(
      environment.apiBaseUrl + "apply-coupon",
      body,
      this.options
    );
  }
}
